"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotPairedView = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _verticalView = require("../item-view/vertical-view");

var _horizontalView = require("../item-view/horizontal-view");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var NotPairedView = function NotPairedView(_ref) {
  var _images$, _images$2, _images$3, _images$4, _images$5, _images$6, _images$7, _images$8, _images$9, _images$10;

  var setDropOffsetRef = _ref.setDropOffsetRef,
      setDropInBetween = _ref.setDropInBetween,
      setDropInFullRef = _ref.setDropInFullRef,
      isCroppedTheme = _ref.isCroppedTheme,
      isHalfTheme = _ref.isHalfTheme,
      isDarkTheme = _ref.isDarkTheme,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      headline1Color = _ref.headline1Color,
      headline2Color = _ref.headline2Color,
      isTablet = _ref.isTablet,
      isDesktop = _ref.isDesktop,
      btnColor = _ref.btnColor;
  var headline1ColorHalfTheme = isHalfTheme ? 'gray800' : headline1Color;
  var headline2ColorHalfTheme = isHalfTheme ? 'gray800' : headline2Color;
  var desktopBtnColor = isHalfTheme || isDarkTheme && !isCroppedTheme ? btnColor : 'gray800';
  var tabletBtnColor = isHalfTheme || isDarkTheme ? btnColor : 'gray800';
  var croppDependedColor = isDesktop ? desktopBtnColor : tabletBtnColor;
  var btnColorHalfTheme = isCroppedTheme && isDarkTheme || isHalfTheme ? 'gray800' : btnColor;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.Row, {
    mdAlignItems: "end",
    lgAlignItems: "start"
  }, ((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    col: 12,
    noGutter: isTablet
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({}, images[0], {
    renditionSrc: (_images$2 = images[0]) === null || _images$2 === void 0 ? void 0 : _images$2.fileReference,
    headline1Color: headline1ColorHalfTheme,
    headline2Color: headline2ColorHalfTheme,
    btnColor: btnColor,
    hideText: true
  }))), ((_images$3 = images[1]) === null || _images$3 === void 0 ? void 0 : _images$3.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    offset: 1.5,
    col: 10.5,
    noGutter: isTablet
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({
    setRef: setDropOffsetRef
  }, images[1], {
    renditionSrc: (_images$4 = images[1]) === null || _images$4 === void 0 ? void 0 : _images$4.fileReference,
    headline1Color: isCroppedTheme ? 'gray800' : headline1ColorHalfTheme,
    headline2Color: isCroppedTheme ? 'gray800' : headline2ColorHalfTheme,
    boxPadding: {
      md: [15, 0, 40],
      lg: [0, 0, 60]
    },
    btnColor: croppDependedColor
  })))), ((_images$5 = images[2]) === null || _images$5 === void 0 ? void 0 : _images$5.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    m: [60, 0, images.length <= 3 ? 0 : 60]
  }, /*#__PURE__*/_react.default.createElement(_horizontalView.HorizontalView, _extends({}, images[2], {
    setRef: setDropInBetween,
    renditionSrc: (_images$6 = images[2]) === null || _images$6 === void 0 ? void 0 : _images$6.fileReference,
    headline1Color: isCroppedTheme && isDarkTheme ? 'white' : headline1Color,
    headline2Color: isCroppedTheme && isDarkTheme ? 'white' : headline2Color,
    boxPadding: {
      md: [15, 0],
      lg: [60, 0]
    },
    isTablet: isTablet,
    btnColor: croppDependedColor
  }))), /*#__PURE__*/_react.default.createElement(_uiKit.Row, {
    alignItems: "end"
  }, ((_images$7 = images[3]) === null || _images$7 === void 0 ? void 0 : _images$7.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    col: 13.7
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({
    boxPadding: [0, 0, 60]
  }, images[3], {
    renditionSrc: (_images$8 = images[3]) === null || _images$8 === void 0 ? void 0 : _images$8.fileReference,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    btnColor: btnColorHalfTheme,
    hideText: true
  }))), ((_images$9 = images[4]) === null || _images$9 === void 0 ? void 0 : _images$9.fileReference) && /*#__PURE__*/_react.default.createElement(_uiKit.Col, {
    offset: 1.5,
    col: 8.8
  }, /*#__PURE__*/_react.default.createElement(_verticalView.VerticalView, _extends({
    boxPadding: [0, 0, 60]
  }, images[4], {
    renditionSrc: (_images$10 = images[4]) === null || _images$10 === void 0 ? void 0 : _images$10.fileReference,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    btnColor: btnColorHalfTheme,
    hideText: true,
    setRef: setDropInFullRef
  })))));
};

exports.NotPairedView = NotPairedView;